<template>
  <v-btn
    v-if="props.show"
    size="small"
    color="primary"
    variant="text"
    class="feedback-button"
    icon="mdi-message-alert-outline"
    tabindex="-1"
    @click="openDialog" />
</template>

<script setup>
const props = defineProps({
  show: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["open"]);

const openDialog = () => {
  emit("open");
};
</script>

<style scoped>
.feedback-button {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  width: 32px;
  height: 32px;
  min-width: 32px;
  padding: 0;
  margin: 0;
}
</style>
